import React, { useState } from "react"
import "./Billing.scss"
import { useHistory } from "react-router"
import Tabs from "@mui/material/Tabs"
import Tab from "@mui/material/Tab"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import TaxCatalog from "./TaxCatalog/TaxCatalog"
import Payment from "./Payment/Payment"
import AddNewTax from "../AddNewTax/AddNewTax"
import AddNewPayment from "./AddNewPayment/AddNewPayment"
// import Payment from "./Payment/payment"
interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}
function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}
function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  }
}
function Billing() {
  const history = useHistory()

  const [value, setValue] = React.useState(0)
  const [editData, setEditData] = useState<any>()
  const [paymentEditData, setpaymentEditData] = useState<any>()

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }

  const [displayNewTaxView, toggleDisplayNewTaxView] = useState<any>();
  const [addEvent, SetAddEvent] = useState(false);



  const [displayNewPaymentView, toggleDisplayNewPaymentView] = useState<any>();
  console.log("Edit test", editData)

  const test = (ele: any) => {
    console.log("Ele", ele)
    toggleDisplayNewTaxView(true)
  }

  return (
    <div className="billing-container">
      <div className="billing-heading">
        <div
          className="billing-back-image"
          onClick={() => {
            history.push('/home')
          }}
        >
          <img
            src={'../../../assets/images/back-icon.svg'}
            height={'60px'}
            width={'60px'}
            alt="back button"
          />
        </div>

        <div className="billing-text">Billing</div>
      </div>
      <Box sx={{ width: "100%", marginTop: "20px" }}>
        <Box sx={{}}>
          <Tabs
            TabIndicatorProps={{
              sx: {
                bgcolor: "blue",
                height: "2px",
                color: "blue",
              },
            }}
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab
              sx={{
                textTransform: "none",
                fontSize: "20px",
                fontWeight: "700",
              }}
              label="Tax Catalog"
              {...a11yProps(0)}
            />
            <Tab
              sx={{
                textTransform: "none",
                fontSize: "20px",
                fontWeight: "700",
              }}
              label="Accepted Modes of Payment"
              {...a11yProps(1)}
            />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          {
            displayNewTaxView ? (
              <AddNewTax onCancel={() => toggleDisplayNewTaxView(false)}
                editData={editData}
              />
            ) : (
              /* eslint-disable */
              <TaxCatalog onAddTaxClick={() => {
                setEditData({}),
                  toggleDisplayNewTaxView(true)
              }
              }
                editTax={(ele: any) => {
                  setEditData(ele)
                }}
              />)}

        </TabPanel>
        <TabPanel value={value} index={1}>
          {
            displayNewPaymentView ? (
              <AddNewPayment onPaymentCancel={() => toggleDisplayNewPaymentView(false)} editData={paymentEditData} />
            ) : (
              <Payment onAddPaymentClick={() => {
                toggleDisplayNewPaymentView(true),
                  setpaymentEditData({})

              }}
                editPayment={(ele: any) => {
                  setpaymentEditData(ele)
                }}

              />)}


          {/* <Payment /> */}
        </TabPanel>

      </Box>

    </div>
  )
}
export default Billing
